import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Country} from "../models/country";
import {CountryService} from "../services/country.service";

@Injectable()
export class CountriesResolve implements Resolve<Country[]> {
    constructor(private countryService: CountryService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Country[]> {
        return this.countryService.getAll();
    }
}